import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
// import Header from './components/Header';
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles,
} from '@material-ui/core/styles';
// import CheckBox from './components/CheckBox';
// import ArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
// import { IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import ArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import classNames from 'classnames';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import AddRemove from './components/AddRemove';
import MultipleSelection from './components/genericmultipleselection';
import GenericSelection from './components/genericselection';
import ItemInfo from './components/ItemInfo';
import strings from './components/language/language';
import Options from './components/Options';
import RadioButton from './components/RadioButton';
import SubmitButton from './components/SubmitButton';
import Title from './components/Title';
import './Iteminfo.css';

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const theme = createMuiTheme({
  palette: {
    primary: { 500: '#70142C' },
  },
});

const styles = (theme) => ({
  backButton: {
    color: '#fff',
    '&:hover': {
      backgroundColor: '#998d9059',
    },
  },
  info: {
    paddingLeft: '30px !important',
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px !important',
    },
  },
  addBasket: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      height: 90,
    },
  },
  bottom: {
    width: '100%',
    marginTop: 30,
  },
  input: {
    '&::placeholder': {
      textAlign: 'right',
    },
  },
});

class AddItem extends Component {
  constructor(props) {
    super(props);
    this.state = { quantity: 1, add_ons: {}, note: '' };
    this.props.chosen_item.add_ons
      ? this.props.chosen_item.add_ons.forEach((element) => {
          if (element.allow_multiple) {
            this.state.add_ons[element.category_name] = [];
          } else {
            var value = element.items[0].price
              ? element.items[0].item_name + '%' + element.items[0].price
              : element.items[0].item_name;
            this.state.add_ons[element.category_name] = value;
          }
        })
      : null;
    if (!this.props.chosen_item) {
      this.props.history.push('/order');
    }
  }

  addQuantity = () => this.setState({ quantity: this.state.quantity + 1 });
  removeQuantity = () => {
    if (this.state.quantity > 1) {
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };

  componentDidMount() {
    if (!this.props.chosen_item) {
      this.props.history.push('/order');
    }
    if (typeof this.props.chosen_item.price === 'number') {
      this.setState({ size: 'regular%' + this.props.chosen_item.price });
    } else {
      this.setState({
        size:
          Object.keys(this.props.chosen_item.price)[0] +
          '%' +
          this.props.chosen_item.price[
            Object.keys(this.props.chosen_item.price)[0]
          ],
      });
    }
    // for(var item in this.props.chosen_item.add_ons.additions){
    //     this.setState({[item.name]:item.items[0]})
    // }
  }
  handleChange = (event) => {
    this.setState({ size: event.target.value });
  };
  handleSelection = (event) => {
    const name = event.target.name;
    this.setState({
      add_ons: { ...this.state.add_ons, [name]: event.target.value },
    });
  };
  handleMultipleSelection = (name) => (event) => {
    let isFound = false;
    let foundIndex = -1;
    this.state.add_ons[name].forEach((element, index) => {
      if (element === event.target.value) {
        isFound = true;
        foundIndex = index;
      }
    });
    if (isFound) {
      var newarr = this.state.add_ons[name];
      newarr.splice(foundIndex, 1);
      this.setState({ add_ons: { ...this.state.add_ons, [name]: newarr } });
    } else {
      var newarr = this.state.add_ons[name];
      newarr.push(event.target.value);
      this.setState({ add_ons: { ...this.state.add_ons, [name]: newarr } });
    }
  };
  render() {
    const { classes, promoCode } = this.props;
    //promo code for order item price
    const promoCodeDiscountOrder =
      (this.props.chosen_item.price / 100) * promoCode;
    const promoCodeOrder =
      this.props.chosen_item.price - promoCodeDiscountOrder;

    let price;
    if (typeof this.props.chosen_item.price === 'number') {
      price = (
        <div id='regular-price'>
          <Grid container spacing xs={0}>
            <Grid item xs={6}>
              <span>{strings.regular_price}</span>
            </Grid>
            <Grid item className='right-align' xs={6}>
              <span
                style={{
                  textDecoration: promoCode ? 'line-through' : 'none',
                }}
              >
                {this.props.chosen_item.price} {strings.currency}
              </span>
              {promoCode && (
                <span style={{ marginLeft: 10 }}>
                  {promoCodeOrder.toFixed(2)} {strings.currency}
                </span>
              )}
            </Grid>
          </Grid>
        </div>
      );
    } else {
      price = (
        <RadioButton
          items={this.props.chosen_item.price}
          click={this.handleChange}
          value={this.state.size}
          promoCode={this.props.promoCode}
          color={this.props.color}
        />
      );
    }
    // let add_ons=[];
    if (this.props.chosen_item.add_ons) {
    }

    return (
      <div>
        {/* <Header />
                <IconButton onClick={this.props.changemode}>
                    <ArrowLeft />
                </IconButton> */}

        <div id='add-item-header' style={{ background: this.props.color }}>
          <NavLink to='/order' style={{ textDecoration: 'none' }}>
            <Button className={classes.backButton}>
              <ArrowLeft /> {strings.back}
            </Button>
          </NavLink>
        </div>

        {/* <AppBar position="static">
          <Toolbar>
            <NavLink to="/">
              <Button variant="outlined" className={classes.button}>
                <ArrowLeft /> Back
                </Button>
            </NavLink>
            <Typography variant="h6" component="h6">
              {this.props.chosen_item.name}
            </Typography>
            <Typography variant="h6" component="h6">
              {this.props.chosen_item.description}
            </Typography>
          </Toolbar>
        </AppBar> */}
        {/* <ItemInfo name={this.props.chosen_item.name}/> */}
        {/* <div>
                    <NavLink to="/"><Icon id="info-back-icon">arrow_back_ios</Icon></NavLink>
                 </div>    */}
        <Grid
          container
          className={classNames(
            classes.mainContainer,
            this.props.chosen_item.image
              ? 'main-container'
              : 'main-container-image'
          )}
          // style={{
          //   width: this.props.chosen_item.image ? '98%' : '43%',
          //   position: this.props.chosen_item.image ? 'static' : 'relative',
          //   left: this.props.chosen_item.image ? '0' : '100px'
          // }}
          style={{
            width: this.props.chosen_item.image ? '100%' : '50%',
            margin: this.props.chosen_item.image ? 'none' : 'auto',
          }}
        >
          <Grid
            item
            md={5}
            sm={this.props.chosen_item.image ? 6 : 12}
            xs={12}
            style={{ padding: 0 }}
            className={
              this.props.chosen_item.image ? 'item-photo-container' : null
            }
          >
            {this.props.chosen_item.image ? (
              //<img id='item-photo' src={this.props.chosen_item.image} />

              <div
                style={{
                  width: '100%',
                  height: '100%',
                  background: `url(${this.props.chosen_item.image}) center center no-repeat`,
                  backgroundSize: 'cover',
                }}
              ></div>
            ) : null}
          </Grid>
          <Grid
            item
            md={this.props.chosen_item.image ? 7 : 12}
            sm={this.props.chosen_item.image ? 6 : 12}
            xs={12}
            className={classes.info}
          >
            <ItemInfo
              name={this.props.chosen_item.name}
              description={this.props.chosen_item.description}
              url={this.props.chosen_item.image}
              lang={this.props.lang}
            />

            {/* <Options name="Select" /> */}

            <div className='prices-container'>
              {/* <RadioButton option="Small" price="12.15zl" />
                    <RadioButton option="Medium" price="15.15zl" />
                    <RadioButton option="Large" price="17.15zl" /> */}
              {price}
            </div>

            {this.props.chosen_item.add_ons
              ? this.props.chosen_item.add_ons.map((addition, index) => {
                  if (addition.allow_multiple) {
                    return (
                      <React.Fragment>
                        <Options name={addition.category_name} />
                        <div className='container2'>
                          <MultipleSelection
                            handleChange={this.handleMultipleSelection}
                            items={addition.items}
                            name={addition.category_name}
                          />
                        </div>
                        <br />
                      </React.Fragment>
                    );
                  } else {
                    return (
                      <React.Fragment>
                        <Options name={addition.category_name} />
                        <div className='container2'>
                          <GenericSelection
                            click={this.handleSelection}
                            value={this.state.add_ons[addition.category_name]}
                            items={addition.items}
                            name={addition.category_name}
                          />
                        </div>
                        <br />
                      </React.Fragment>
                    );
                  }
                })
              : null}

            {!this.props.isMenu ? (
              <div
                className={classes.bottom}
                style={{
                  textAlign:
                    (this.props.lang === 'ar') | (this.props.lang === 'qrAR')
                      ? 'right '
                      : 'left ',
                }}
              >
                <Title name={strings.special_instructions} />
                {/* <Grid container justify="center" alignItems="center">
              <Grid xs={10}> */}
                <div className='item-container'>
                  <div id='item'>
                    <MuiThemeProvider theme={theme}>
                      <TextField
                        placeholder={strings.ex_Without_onions}
                        fullWidth
                        multiline
                        rowsMax='4'
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          classes: {
                            input:
                              (this.props.lang === 'ar') |
                              (this.props.lang === 'qrAR')
                                ? classes.input
                                : null,
                          },
                        }}
                        inputProps={{
                          style: {
                            textAlign:
                              (this.props.lang === 'ar') |
                              (this.props.lang === 'qrAR')
                                ? 'right'
                                : 'unset',
                          },
                        }}
                        value={this.state.note}
                        onChange={(e) =>
                          this.setState({ note: e.target.value })
                        }
                      />
                    </MuiThemeProvider>
                  </div>
                </div>
                <br />
                <br />
                {/* <Options name="Quantity" /> */}
                <Grid container spacing={8}>
                  <Grid item md={6} xs={12}>
                    <div>
                      <AddRemove
                        addQuantity={this.addQuantity}
                        removeQuantity={this.removeQuantity}
                        quantity={this.state.quantity}
                        color={this.props.color}
                      />
                    </div>
                  </Grid>
                  <br />
                  <Grid item md={6} xs={12} className={classes.addBasket}>
                    <div style={{ textAlign: 'center' }}>
                      <SubmitButton
                        cart={this.props.cart}
                        messenger_user_id={this.props.messenger_user_id}
                        restaurant_name={this.props.restaurant_name}
                        click={() =>
                          this.props.click(
                            this.props.chosen_item,
                            this.state.quantity,
                            this.state.size,
                            this.state.add_ons,
                            null,
                            this.state.note
                          )
                        }
                        color={this.props.color}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            ) : null}
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default withStyles(styles)(AddItem);



// WEBPACK FOOTER //
// ./src/AddItem.js